import { createOvermind } from 'overmind'
import { namespaced } from 'overmind/config'
import { createHook } from 'overmind-react'

import * as menu from './menu/state'
import * as form from './form/state'

export const config = namespaced({
  menu,
  form
})

export const useOvermind = createHook()

export const overmind = createOvermind(config, {
  hotReloading: false,
  logProxies: false
})
